import { render, staticRenderFns } from "./reportsAddWasteForm.vue?vue&type=template&id=b07cf16e&scoped=true"
import script from "./reportsAddWasteForm.vue?vue&type=script&lang=js"
export * from "./reportsAddWasteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07cf16e",
  null
  
)

export default component.exports